import React from 'react'

export type KindTypes = 'primary' | 'secondary'

type Props = {
  children: React.ReactNode
  className?: string
  key?: string
  kind?: KindTypes
  id?: string
  style?: React.CSSProperties
  tabIndex?: number
  ariaLabel?: string
  ariaLabelledBy?: string
}

const Section: React.FC<Props> = props => {
  const {
    children,
    className = '',
    key,
    kind = 'primary',
    id,
    style,
    tabIndex,
    ariaLabel,
    ariaLabelledBy,
  } = props
  const bkg = kind === 'secondary' ? 'grey-10-bkg' : 'white-bkg'
  // Promote to a named landmark only when the caller supplies a name.
  // An unlabelled `role="region"` is itself a WCAG 4.1.2 violation.
  const role = ariaLabel || ariaLabelledBy ? 'region' : undefined
  return (
    <div
      id={id}
      style={style}
      tabIndex={tabIndex}
      role={role}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={`${bkg} grey-20-border rounded border-1 ${className}`}
      key={key}
    >
      {children}
    </div>
  )
}

export default Section
